import { API } from '@config';
import { WorkSignsResidentTable } from '@src/types/WorkSignsResidents';

export const getWorkSignsResidential = async () => {
  const options = {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
  };
  const response = await fetch(`${API}/api/residential-fn-p-work-signs?populate=File&sort=id%3Adesc`, options);
  const data: WorkSignsResidentTable = await response.json();

  return data;
};
